import React from 'react'

const Index = (props) => {
  return <div className='app-body'>{props.children}</div>
}

export default Index
